//#region src/integrations/deepgram/deepgramTypes.ts
const DEEPGRAM_INTEGRATION_ID = "deepgram";

//#endregion
export { DEEPGRAM_INTEGRATION_ID };
//# sourceMappingURL=deepgramTypes.js.map